// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1K8sF","inner":"Footer_inner__fKhVf"};